export const container = `flex flex-col gap-3 text-xs text-gray-800 font-medium`;
export const loading = `h-5 w-20 bg-gray-200 animate-pulse rounded-md`;
export const button = `p-0 text-xs h-auto w-auto justify-start cursor-pointer`;
